import React, { useState, useEffect } from 'react';
// import { base44 } from '@/api/base44Client';
import Icon from '../components/ui/Icon';
import AgentCard from '../components/agents/AgentCard';
import AgentForm from '../components/agents/AgentForm';


const placeholderAgents = [
  {
    id: '1',
    full_name: 'Alice Johnson',
    email: 'alice@example.com',
    license_number: 'AB12345',
    status: 'active',
    photo_url: ''
  },
  {
    id: '2',
    full_name: 'Bob Smith',
    email: 'bob@example.com',
    license_number: 'CD67890',
    status: 'pending',
    photo_url: ''
  },
  {
    id: '3',
    full_name: 'Carol Davis',
    email: 'carol@example.com',
    license_number: 'EF11223',
    status: 'inactive',
    photo_url: ''
  }
];

export default function Agents() {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingAgent, setEditingAgent] = useState(null);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  // const loadAgents = async () => {
  //   const data = await base44.entities.Agent.list('-created_date');
  //   setAgents(data);
  //   setLoading(false);
  // };

// Temporary local load function
  const loadAgents = async () => {
    // simulate loading delay
    setAgents(placeholderAgents);
    setLoading(false);
  };

  useEffect(() => { loadAgents(); }, []);

  // const handleSave = async (data) => {
  //   if (editingAgent) {
  //     await base44.entities.Agent.update(editingAgent.id, data);
  //   } else {
  //     await base44.entities.Agent.create(data);
  //   }
  //   setShowForm(false);
  //   setEditingAgent(null);
  //   loadAgents();
  // };

  // Temporary local save handler
  const handleSave = async (data) => {
  if (editingAgent) {
    setAgents(prev => prev.map(a => a.id === editingAgent.id ? { ...a, ...data } : a));
  } else {
    setAgents(prev => [...prev, { id: Date.now().toString(), ...data }]);
  }
  setShowForm(false);
  setEditingAgent(null);
};


  const handleEdit = (agent) => {
    setEditingAgent(agent);
    setShowForm(true);
  };

  const filteredAgents = agents.filter(agent => {
    const matchesSearch = !search ||
      agent.full_name?.toLowerCase().includes(search.toLowerCase()) ||
      agent.email?.toLowerCase().includes(search.toLowerCase()) ||
      agent.license_number?.toLowerCase().includes(search.toLowerCase());
    const matchesStatus = statusFilter === 'all' || agent.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const statusCounts = {
    all: agents.length,
    active: agents.filter(a => a.status === 'active').length,
    pending: agents.filter(a => a.status === 'pending').length,
    inactive: agents.filter(a => a.status === 'inactive').length
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--slate-50)', padding: '2rem' }}>
      <div style={{ maxWidth: '80rem', margin: '0 auto' }}>
        {/* Header */}
        <div className="flex flex-wrap items-center justify-between mb-8 gap-4">
          <div>
            <h1 className="text-3xl font-bold text-slate-900">Agents</h1>
            <p className="text-slate-500 mt-1">Manage your real estate team</p>
          </div>
          <button className="btn btn-primary" onClick={() => { setEditingAgent(null); setShowForm(true); }}>
            <Icon name="plus" size={16} />
            Onboard Agent
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-4 gap-4 mb-8">
          <div className="card p-4">
            <div className="flex items-center gap-3">
              <div style={{ padding: '0.5rem', background: 'var(--slate-100)', borderRadius: '0.5rem' }}>
                <Icon name="users" size={20} style={{ color: 'var(--slate-600)' }} />
              </div>
              <div>
                <p className="text-2xl font-bold text-slate-900">{statusCounts.all}</p>
                <p className="text-sm text-slate-500">Total Agents</p>
              </div>
            </div>
          </div>
          <div className="card p-4">
            <div className="flex items-center gap-3">
              <div style={{ padding: '0.5rem', background: 'var(--emerald-50)', borderRadius: '0.5rem' }}>
                <Icon name="userCheck" size={20} style={{ color: 'var(--emerald-600)' }} />
              </div>
              <div>
                <p className="text-2xl font-bold text-slate-900">{statusCounts.active}</p>
                <p className="text-sm text-slate-500">Active</p>
              </div>
            </div>
          </div>
          <div className="card p-4">
            <div className="flex items-center gap-3">
              <div style={{ padding: '0.5rem', background: '#fef3c7', borderRadius: '0.5rem' }}>
                <Icon name="clock" size={20} style={{ color: 'var(--amber-600)' }} />
              </div>
              <div>
                <p className="text-2xl font-bold text-slate-900">{statusCounts.pending}</p>
                <p className="text-sm text-slate-500">Pending</p>
              </div>
            </div>
          </div>
          <div className="card p-4">
            <div className="flex items-center gap-3">
              <div style={{ padding: '0.5rem', background: 'var(--slate-50)', borderRadius: '0.5rem' }}>
                <Icon name="userX" size={20} style={{ color: 'var(--slate-400)' }} />
              </div>
              <div>
                <p className="text-2xl font-bold text-slate-900">{statusCounts.inactive}</p>
                <p className="text-sm text-slate-500">Inactive</p>
              </div>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="flex flex-wrap gap-4 mb-6">
          <div style={{ position: 'relative', flex: 1, maxWidth: '24rem' }}>
            <Icon name="search" size={16} style={{ position: 'absolute', left: '0.75rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--slate-400)' }} />
            <input
              className="input input-with-icon"
              placeholder="Search agents..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className="tabs">
            {['all', 'active', 'pending', 'inactive'].map(status => (
              <button
                key={status}
                className={`tab ${statusFilter === status ? 'active' : ''}`}
                onClick={() => setStatusFilter(status)}
              >
                {status.charAt(0).toUpperCase() + status.slice(1)} {status === 'all' && `(${statusCounts.all})`}
              </button>
            ))}
          </div>
        </div>

        {/* Agents Grid */}
        {loading ? (
          <div className="grid grid-3 gap-4">
            {[1, 2, 3, 4, 5, 6].map(i => <div key={i} className="skeleton" style={{ height: '16rem' }} />)}
          </div>
        ) : filteredAgents.length > 0 ? (
          <div className="grid grid-3 gap-4">
            {filteredAgents.map(agent => (
              <AgentCard key={agent.id} agent={agent} onEdit={handleEdit} />
            ))}
          </div>
        ) : (
          <div className="card" style={{ textAlign: 'center', padding: '4rem' }}>
            <Icon name="users" size={48} style={{ color: 'var(--slate-300)', margin: '0 auto 1rem' }} />
            <h3 className="text-lg font-medium text-slate-900 mb-2">No agents found</h3>
            <p className="text-slate-500 mb-4">
              {search ? 'Try adjusting your search' : 'Start by onboarding your first agent'}
            </p>
            <button className="btn btn-primary" onClick={() => { setEditingAgent(null); setShowForm(true); }}>
              <Icon name="plus" size={16} />
              Onboard Agent
            </button>
          </div>
        )}
      </div>

      <AgentForm
        open={showForm}
        onClose={() => { setShowForm(false); setEditingAgent(null); }}
        agent={editingAgent}
        onSave={handleSave}
      />
    </div>
  );
}